import clsx from "clsx"
import { forwardRef } from "react"
import { Icon } from "../Icon"
import styles from "./index.module.css"

const Button = forwardRef(
  ({
    as = "button", 
    className, 
    variant = "regular", 
    size = "medium", 
    disabled = false,
    fullWidth = false,
    icon,
    children,
    ...props 
  }, ref) => {
    const cls = clsx(
      styles.button, 
      variant === 'regular' && styles.regular,
      variant === 'outline' && styles.outline,
      variant === 'ghost' && styles.ghost,
      size === 'small' && styles.small,
      size === 'medium' && styles.medium,
      size === 'large' && styles.large,
      disabled && styles.disabled,
      fullWidth && styles.fullWidth,
      icon && styles.hasIcon,
      className
    );

    const Component = as;

    return (
      <Component 
        className={cls} 
        ref={ref} 
        {...props} 
      >
        {children}
        {icon && (
          <span 
            className={clsx(
              styles.icon,
              disabled ? styles.iconDisabled : styles.iconEnabled
            )}
          >
            <Icon name={icon} size={icon === 'play' ? 12 : 24} color={disabled ? 'var(--color-neutral-700)' : 'var(--color-accent-500)'} />
          </span> 
        )}
      </Component>
    )
  }
)

Button.displayName = "Button"

export { Button }